import { createFileRoute } from "@tanstack/react-router";
import AdminFileActivity from "@/pages/AdminFileActivity";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/file-activity/")({
  component: () => (
    <RoleGate allow={['staff','viewer']} area="File Activity"><AdminFileActivity /></RoleGate>
  ),
});
